import React, { useState, useEffect }  from 'react';

import {Link, useNavigate} from 'react-router-dom';
import { collection, getDocs, } from "firebase/firestore";
import {db} from '../../firebase'
function Slider() {
   const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
  
      const [showPerPage, setShowPerPage] = useState(9);
      const [pagination, setPagination] =useState({
          start: 0,
          end: showPerPage,
      });
  
      const onPaginationChange = (start,  end) =>{
          setPagination({start: start, end: end});
      };
      const [searchTerm, setsearchTerm] = useState("");
      const [slide, setSlide] = useState([])
      const navigate = useNavigate()
  
      const slideCollectionRef = collection(db, "slide");
      useEffect(() => {
  
          const getSlide = async () => {
              const data = await getDocs(slideCollectionRef);
              setSlide(data.docs.map((doc) => ({...doc.data(), id: doc.id })))
          }
  
          getSlide()
      }, [])
  return (
    <div>

{slide.filter((val)=>{
      if (setsearchTerm === ""){
        return val;
      } {
        return val;
      }
    }).slice(pagination.start, pagination.end).map((psluxuryhotel) => { return (
       
       
                       
                            <div className="card-body">
                                   
      <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
      <div className="carousel-indicators">
        
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
      
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
       
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
          
        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3" aria-label="Slide 4"></button>

        <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4" aria-label="Slide 5"></button>
    
    
      </div>
      <div className="carousel-inner">
        <div className="carousel-item active">
          <div className="radius">
          <img src={psluxuryhotel.slider1} className="d-block w-100" alt="ps-luxury-hotel"/>
          </div>
        </div>
        <div className="carousel-item">
          <div className="radius">
          <img src={psluxuryhotel.slider2} className="d-block w-100" alt="ps_luxury_hotel"/>
        </div>
        </div>
       
        <div className="carousel-item">
          <div className="radius">
          <img src={psluxuryhotel.slider3} className="d-block w-100" alt="ps-luxury-hotel"/>
        </div>
        </div>
      
      <div className="carousel-item">
         <div className="radius">
          <img src={psluxuryhotel.slider4} className="d-block w-100" alt="ps-luxury-hotel"/>
          </div>
        </div>
        <div className="carousel-item">
           <div className="radius">
          <img src={psluxuryhotel.slider5} className="d-block w-100" alt="ps-luxury-hotel"/>
        </div>
        </div>
       
      </div>
     
      <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  
                                
                               
                              
                                {/* <h5 style={{color: "Darkblue"}}className="card-text"> ₹{website.saleprice} </h5>
                                <p style={{color: "Gray"}}className="card-text mb-2"> M.R.P.: <del> ₹{website.delete}</del> </p> */}
                               

                               
                    
                              
                            </div>
                           
                                )})} 
                            
                            {/* <PaginationOld showPerPage={showPerPage} 
                onPaginationChange={onPaginationChange}
                total={slide.length}
                /> */}
      
    </div>
  )
}

export default Slider
